import { ErrorMessage, useFormikContext } from "formik";
import BsForm from "react-bootstrap/Form";
import { INTENDED_USE_OPTIONS } from "../constants/sealRegistrationConstants";
import { SealRegistrationFormData } from "../SealRegistrationContext";
import { SealInfoBox } from "../components/SealInfoBox";

export const IntendedSealUseSection = () => {
  const { values, setFieldValue } = useFormikContext<SealRegistrationFormData>();

  const isPackagingBlockedByRole =
    values.intendedUse.packaging &&
    !values.roles.producer &&
    !values.roles.brandOwner;

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Intended seal use</h2>
      <p className="form-fields-sub-text" style={{ marginBottom: "10px" }}>
        How does the registered brand or business intend to use the OVR Seal?
        Select all that apply.
      </p>

      {INTENDED_USE_OPTIONS.map((use) => (
        <div key={use.key}>
          <BsForm.Check
            label={use.label}
            className="checkbox-label-text"
            checked={values.intendedUse[use.key] || false}
            onChange={() =>
              setFieldValue(
                `intendedUse.${use.key}`,
                !values.intendedUse[use.key]
              )
            }
          />
          {use.key === "packaging" && isPackagingBlockedByRole && (
            <div className="input-error" style={{ marginLeft: "30px", marginTop: "6px" }}>
              Packaging use is available only through registration of the
              consumer-facing wine brand by its producer or brand owner.
            </div>
          )}
        </div>
      ))}
      <ErrorMessage name="intendedUse" className="input-error" component="span" />

      {values.intendedUse.packaging && (
        <div className="seal-packaging-confirm">
          <BsForm.Check
            className="checkbox-label-text"
            checked={values.packagingConfirmation}
            onChange={() =>
              setFieldValue(
                "packagingConfirmation",
                !values.packagingConfirmation
              )
            }
            label="I confirm that the name being registered is the consumer-facing wine brand that will use the seal on its packaging and that I am authorized to control packaging for that brand."
          />
          <ErrorMessage
            name="packagingConfirmation"
            className="input-error"
            component="span"
          />
          <span className="form-fields-sub-text" style={{ marginLeft: "30px" }}>
            Each separately marketed wine brand that uses the seal on packaging
            requires its own registration.
          </span>
        </div>
      )}

      {(values.roles.importer || values.roles.retailer) && (
        <SealInfoBox>
          Importers and retailers may use the seal in their own websites,
          listings, catalogs, wine lists, shelf talkers, and promotional
          materials. Their registration does not register the wine brands they
          carry or authorize those brands to use the seal on packaging.
        </SealInfoBox>
      )}
    </div>
  );
};
